export interface NavItem {
  readonly to: string
  readonly label: string
  readonly icon: string
  readonly badge?: string
  /** Shown in the mobile tab bar. Exactly four should carry this. */
  readonly primary?: boolean
  /** Not built yet — rendered, but marked so nobody demos a dead end. */
  readonly upcoming?: boolean
}

export interface NavGroup {
  readonly id: string
  readonly label: string
  readonly items: readonly NavItem[]
}

export const NAV_GROUPS: readonly NavGroup[] = [
  {
    id: 'money',
    label: 'Money',
    items: [
      { to: '/', label: 'Home', icon: 'home', primary: true },
      { to: '/accounts', label: 'Accounts', icon: 'account_balance', badge: '4', primary: true },
      { to: '/cards', label: 'Cards', icon: 'credit_card', badge: '2', primary: true },
      { to: '/transactions', label: 'Transactions', icon: 'receipt_long' },
      { to: '/insights', label: 'Insights', icon: 'monitoring' },
    ],
  },
  {
    id: 'move',
    label: 'Move money',
    items: [
      { to: '/transfers', label: 'Transfers', icon: 'swap_horiz', primary: true },
      { to: '/add-money', label: 'Add money', icon: 'add_circle' },
      { to: '/convert', label: 'Convert', icon: 'currency_exchange' },
      { to: '/receive', label: 'Receive', icon: 'south_west' },
      { to: '/transfers/recipients', label: 'Recipients', icon: 'group' },
    ],
  },
  {
    id: 'grow',
    label: 'Grow',
    items: [
      { to: '/invest', label: 'Invest', icon: 'trending_up' },
      { to: '/real-assets', label: 'Real assets', icon: 'apartment' },
      { to: '/crypto', label: 'Crypto wallet', icon: 'account_balance_wallet' },
    ],
  },
  {
    id: 'explore',
    label: 'Explore',
    items: [
      { to: '/travel', label: 'Travel', icon: 'flight', badge: 'New' },
      { to: '/wellness', label: 'Wellness', icon: 'spa' },
      { to: '/gym', label: 'Gyms', icon: 'exercise' },
      { to: '/esim', label: 'Travel eSIM', icon: 'sim_card' },
    ],
  },
]

export const UTILITY_ITEMS: readonly NavItem[] = [
  { to: '/notifications', label: 'Notifications', icon: 'notifications' },
  { to: '/cashback', label: 'Cashback', icon: 'redeem' },
  { to: '/plans', label: 'Plans', icon: 'workspace_premium' },
  { to: '/support', label: 'Support', icon: 'support_agent' },
  { to: '/profile', label: 'Profile & security', icon: 'shield' },
  { to: '/settings', label: 'Settings', icon: 'settings' },
]

export const PRIMARY_ITEMS: readonly NavItem[] = NAV_GROUPS.flatMap((group) =>
  group.items.filter((item) => item.primary),
)

/** Every route the sidebar can reach, used by the command palette and tests. */
export const ALL_NAV_ITEMS: readonly NavItem[] = [
  ...NAV_GROUPS.flatMap((group) => group.items),
  ...UTILITY_ITEMS,
]
